"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section } from "@/src/components";
import { Pagination } from "@/src/components/navigation/pagination";

export default function DocsBlocksPagination() {
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);

  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Pagination
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Navigation component for paginated content with page size controls and smart page number display.
          </Text>
        </div>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Interactive pagination</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <Pagination
            pageNo={page}
            noOfPage={20}
            pageSize={pageSize}
            enablePageSize
            showPageNumber
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
          />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">pageNo</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 text-muted-foreground">Current page number</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">noOfPage</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 text-muted-foreground">Total number of pages</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">pageSize</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 text-muted-foreground">Items per page</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">enablePageSize</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">boolean</td>
                <td className="py-2 text-muted-foreground">Show page size selector</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onPageChange</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">(page: number) =&gt; void</td>
                <td className="py-2 text-muted-foreground">Page change handler</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">onPageSizeChange</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">(size: number) =&gt; void</td>
                <td className="py-2 text-muted-foreground">Page size change handler</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
